import React from 'react'
import { InputContainer } from '../../../common/components/form/form.module';
import { currency } from '../../../common/services/common.service';
import { RotatingLines } from 'react-loader-spinner';

export default function ModalEstimateComponent({ selectedEstimateItem, selectedVehicleItem,
    isButtonLoading, handleEstimateSubmit, productTypeCargo, handleInnerFormChange }: any) {

    return (

        <div className="w-full p-4 bg-white">
            <h1 className="text-xl font-semibold mb-4 text-center">Get an Estimate</h1>

            {/* Main Sections */}
            <div className="grid md:grid-cols-2 gap-6">
                {/* Left Section */}
                <div className="p-4">
                    <div className="border-b-2 border-gray-300 bg-white text-center w-64 p-4 ">
                        <div className="text-lg font-semibold">{selectedVehicleItem?.VehicleType}</div>

                        {/* Image or Placeholder */}
                        <div className="flex items-center justify-center w-full h-36 p-3">
                            {selectedVehicleItem?.vehicleImageUrl ? (
                                <img src={selectedVehicleItem.vehicleImageUrl} className="w-36 h-36 object-contain" alt="Vehicle" />
                            ) : (
                                <svg fill="#000000" height="155px" width="155px" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                                    <g><path d="M106.846,320c-28.237,0-51.2,22.963-51.2,51.2c0,28.237,22.963,51.2,51.2,51.2s51.2-22.963,51.2-51.2 C158.046,342.963,135.074,320,106.846,320z M106.846,405.333c-18.825,0-34.133-15.309-34.133-34.133s15.309-34.133,34.133-34.133 s34.133,15.309,34.133,34.133S125.662,405.333,106.846,405.333z"></path></g>
                                </svg>
                            )}
                        </div>

                        <div className="mt-2 text-sm font-medium text-gray-600">
                            <p>Vehicle Weight: {selectedVehicleItem?.VehicleWeight}</p>
                            <p>Capacity: Upto {selectedVehicleItem?.LoadingCapacity} Kg</p>
                        </div>

                        {/* <div className="mt-2 text-2xl font-semibold text-gray-700">
                                    {currency(selectedVehicleItem?.Price)}
                                </div> */}
                    </div>

                    {/* Product Type Selection */}
                    <div className="my-4">
                        <InputContainer
                            labelField="Name"
                            list={productTypeCargo}
                            onValueChange={(event, newValue) => handleInnerFormChange(event.target.value, 'CategoryId')}
                            optionName="Product Type"
                            type="select"
                            value={selectedEstimateItem?.CategoryId}
                            valueField="Id"
                        />
                    </div>
                    <div>
                        <InputContainer

                            placeholder="Enter the APX. Product Value"
                            name="value"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'ProductValue'

                                )
                            }}
                            type="number"
                            value={selectedEstimateItem?.ProductValue}
                        />
                        <span
                            className="block text-xs font-light text-right"
                        >
                            in ₹
                        </span>
                    </div>
                </div>

                {/* Right Section */}
                <div className="p-4 border-l-2 border-gray-300">
                    <div className="space-y-4">
                        <div className="py-2">
                            <div className="text-base font-medium text-gray-800">PickUp Address</div>
                            <div className="text-sm font-medium text-gray-600">{selectedEstimateItem?.Pickup}</div>
                        </div>
                        <div className="py-2">
                            <div className="text-base font-medium text-gray-800">Drop Address</div>
                            <div className="text-sm font-medium text-gray-600">{selectedEstimateItem?.Drop}</div>
                        </div>
                        <div className="py-2">
                            <div className="text-base font-medium text-gray-800">Name</div>
                            <div className="text-sm font-medium text-gray-600">{selectedEstimateItem?.Name}</div>
                        </div>
                        <div className="py-2">
                            <div className="text-base font-medium text-gray-800">Phone Number</div>
                            <div className="text-sm font-medium text-gray-600">{selectedEstimateItem?.PhoneNumber}</div>
                        </div>

                    </div>

                    {/* Get Estimate Button */}
                    <div className="mt-6 text-center">
                        <button
                            disabled={isButtonLoading}
                            onClick={handleEstimateSubmit}
                            type="button"
                            className={`${isButtonLoading ? 'bg-primary bg-opacity-70 ' : 'bg-primary'} w-full rounded-md h-10 text-light items-center justify-center flex flex-row   border-x border-y  px-2 py-1 text-sm font-bold `}
                        >
                            Get an Estimate
                            {isButtonLoading && <div className={`${isButtonLoading ? 'visible' : 'invisible'}`}>
                                <RotatingLines
                                    visible={true}
                                    width={'20'}
                                    strokeColor="#fff"
                                    strokeWidth="6"
                                    animationDuration="0.75"
                                    ariaLabel="rotating-lines-loading"
                                />
                            </div>}
                        </button>
                    </div>
                </div>
            </div>
        </div>



    )
}